"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Toggleable = _interopRequireDefault(require("../../../darkmatter/Toggleable"));

var _MenuItems = _interopRequireDefault(require("./MenuItems"));

var _default = function _default(_ref) {
  var logo = _ref.logo,
      position = _ref.position,
      links = _ref.links,
      linksAs = _ref.linksAs,
      className = _ref.className,
      centerMobileNavItems = _ref.centerMobileNavItems,
      backgroundColor = _ref.backgroundColor,
      invertedHamburgerButton = _ref.invertedHamburgerButton;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
    className: className,
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_Toggleable["default"], null, function (toggle, onToggle) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mobile-nav-header"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      onClick: onToggle,
      style: {
        "float": position === 'left' ? 'right' : 'left'
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      inverted: invertedHamburgerButton,
      name: "bars",
      size: "large",
      color: "primary",
      style: {
        margin: '0 auto',
        height: 'unset'
      }
    })), /*#__PURE__*/_react["default"].createElement("div", null, logo)), toggle && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu, {
      vertical: true,
      className: "mobile-nav-menu"
    }, /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
      links: links,
      linksAs: linksAs
    })));
  }));
};

exports["default"] = _default;